import $ from "jquery";

$(function () {
    var cdnHost = $('#meta__build_version').length && $('#meta__build_version').attr('data-host');
    var $popup = $('#user-agreement');
    var $btnAccept = $('.js-btn-accept');

    if (cdnHost) {
        getDownloadVersions(cdnHost);

        $('.btn-download .btn').click(function (event) {
            var $btn = $(event.target).closest('.btn');
            var cdnFile = $btn.data('url') || '';

            $popup.find('.system-requirements').hide();
            $popup.find('.platform_' + $btn.data('platform')).show();

            $btnAccept.data('url', cdnFile);
        });

        $btnAccept.on('click', function (event) {
            var cdnFile = $(event.target).closest('.btn').data('url');
            if (!cdnFile) {
                return;
            }

            gtagDownload(cdnHost + cdnFile);
        });
    }
});

function gtagDownload(url) {
    if (!gtag || !window.google_tag_manager) {
        document.location = url;
        return;
    }
    gtag('event', 'download', {
        'transport_type': 'beacon',
        'event_category': 'cascadeur-beta',
        'event_label': url,
        'event_callback': function () {
            document.location = url;
        }
    });
}

function getDownloadVersions(host) {
    var versions = [];
    var meta = $('#meta__build_version').attr('data-meta');

    $.getJSON(host + meta, {})
        .done(function (data) {
            var $select = $('#group__build_version .custom-select');
            var options = '';

            if (!data) {
                console.error('CDN meta file is empty');
                return
            }

            $('.main-promo__buttons .btn-download').hide();

            data.forEach(function (version, index) {
                version.description = formatDownloadDescription(version.description);

                if (index === 0) {
                    $('#main-promo__version-date').text((new Date(version.release_date)).toDateString());
                    $('#main-promo__version-version').text(version.name);
                    $('.main-promo__version-info').fadeTo(900, 1);

                    setDownloadPlatforms(version.platforms);

                    fillDescription('#main-promo__build_version', version);

                    return;
                }

                options += '<option value="' + (index - 1) + '">Cascadeur ' + version.name + '</option>';

                versions.push(version);
            });

            $select
                .find('option')
                .remove()
                .end()
                .append(options)
                .val(0)
                .change();
        })
        .fail(function (data) {
            console.error('Can\'t get CDN meta file', data)
        });

    $('#group__build_version .custom-select').change(function (event) {
        var id = $(event.target).closest('.custom-select').val();
        var version = versions[id];

        setDownloadVersionInfo(version);
    });
}

function formatDownloadDescription(text) {
    return '<p>' + text.replace(/"/g, '\'').replace(/(\n\n|\r\r|\r\n){2}/g, '</p><p>').replace(/(\n\n|\r\r|\r\n)/g, '<br>') + '</p>';
}

function setDownloadVersionInfo(version) {
    var platforms = version.platforms;

    $('#group__build_version__date').text((new Date(version.release_date)).toDateString());

    $('#group__build_version__version').text(version.name);

    $('.version-information .btn-download').hide();

    setDownloadPlatforms(platforms, 'previous_');

    fillDescription('#group__build_version__description', version);
}

function fillDescription(selector, version) {
    var $description = $(selector);

    $description.attr('data-content', '<div class=\'popover-title\'>' + $description.attr('data-subtitle') + '</div>' + version.description);

    $description.attr('data-original-title', $description.attr('data-title-prefix') + ' <strong>' + version.name + '</strong>');
}

function setDownloadPlatforms(platforms, prefix = '') {
    platforms.forEach(function (platform) {
        console.log(platform);
        var $button = $('#btn_download__' + prefix + platform.machine_name);

        if ($button.length) {
            $button.find('.main-download__bottom').data('url', platform.path);
            $button.find('.main-download__button-size').text(formatSize(platform.size));
            $button.show();
        }
    });
}

function formatSize(size) {
    var suffixes = ['KB', 'MB', 'GB'];

    for (var i = 0; i < suffixes.length; i++) {
        size = size / 1024;
        if (size < 1024) {
            return Math.round(size * 10) / 10 + ' ' + suffixes[i];
        }
    }
    Math.round(size * 10) / 10 + ' ' + suffixes[i - 1];
}
